export const makeToast = (context, variant, message) => {
  let title = variant.toLowerCase() == "success" ? "Success" : "Danger";
  context.$bvToast.toast(message, {
    title: title,
    variant: variant,
    solid: true,
  });
  return Promise.resolve();
};
